import { qsa } from 'modules/dom';

function findInputForName(form, name) {
  const pattern = new RegExp(`\\[${name}\\](?|$)`);
  return qsa('input, select, textarea', form).find((field) => pattern.test(field.name || ''));
}

function findFieldWrapper(input) {
  return input?.closest('.mb-3, .mb-2, .form-group');
}

function normalizeErrors(errors) {
  if (!errors) return null;
  if (errors.errors && typeof errors.errors === 'object') return errors.errors;

  return errors;
}

function errorMessages(messages) {
  if (Array.isArray(messages)) return messages.join(', ');
  if (messages) return String(messages);

  return '';
}

function removeAllErrors(form) {
  qsa('.mb-3, .mb-2, .form-group', form).forEach((group) => {
    group.classList.remove('has-error', 'is-invalid');
    qsa('.help-block, .invalid-feedback, span.error', group).forEach((block) => block.remove());
    qsa('input, select, textarea', group).forEach((field) => field.classList.remove('is-invalid'));
  });
}

function applyErrors(form, errors) {
  const normalized = normalizeErrors(errors);
  if (!normalized) return;

  Object.entries(normalized).forEach(([key, messages]) => {
    if (key === 'full_messages') return;

    const messageText = errorMessages(messages);
    if (!messageText) return;

    const input = findInputForName(form, key);
    if (!input) return;

    const group = findFieldWrapper(input);
    if (!group) return;

    input.classList.add('is-invalid');
    group.classList.add('is-invalid');

    const help = document.createElement('div');
    help.className = 'invalid-feedback d-block';
    help.textContent = messageText;
    group.appendChild(help);
  });
}

export function renderBootstrapErrors(form, errors) {
  if (!form || !errors) return;
  removeAllErrors(form);
  applyErrors(form, errors);
}

globalThis.renderBootstrapErrors = renderBootstrapErrors;
